import { CompoundDetailsWithRelatedDataDomain } from 'compoundTypes'
import { RelationItem } from 'evidenceTypes'
import {
    Compound,
    DataDomainItems,
    Driver,
    MappedDriver,
    MappedDriverItem,
    MappedTarget,
    Target
} from 'reportViewer'

export function isCompoundDomain(data: any): data is Compound {
    return data && 'compound' in data
}

export function isCompoundDomainArray(data: any[]): data is Compound[] {
    return data.length > 0 && 'compound' in data[0]
}

export function isTargetDomain(data: any): data is Target {
    return data && 'target' in data
}

export function isTargetDomainArray(data: any[]): data is Target[] {
    return data.length > 0 && 'target' in data[0]
}

export function isDriverDomain(item: any): item is Driver {
    return 'item' in item && 'gene' in item.item
}

export function isMappedCompound(
    item: DataDomainItems[number]
): item is CompoundDetailsWithRelatedDataDomain {
    return 'compoundId' in item && 'category' in item
}

export function isMappedTarget(
    item: DataDomainItems[number]
): item is MappedTarget {
    return !('compoundId' in item) && !('driverClassification' in item)
}

export function isMappedDriver(
    item: DataDomainItems[number]
): item is MappedDriver {
    return 'driverClassification' in item
}

export function isRelationItem(data: any): data is RelationItem {
    return (
        typeof data === 'object' &&
        data !== null &&
        (
            'geneName' in data ||
            'mutationName' in data ||
            'testType' in data ||
            'testResult' in data
        )
    )
}

export const isBiomarkerItem = (
    data: unknown
): data is Exclude<MappedDriverItem, null> => {
    return (
        typeof data === 'object' &&
        data !== null &&
        ('gene' in data || 'mutation' in data)
    )
}
